export const blockIconsHomeNestHeatLinkENew = (
	<span className='material-symbols-outlined'>nest_heat_link_e</span>
);
